import React from 'react';
import styles from './Sidebar.module.css';

const Sidebar = ({ activeTab, setActiveTab }) => {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'clients', label: 'Clients', icon: '👥' },
  ];

  const handleLogout = async () => {
    // Basic sign out
    import('../../services/authService').then(({ logoutUser }) => {
       logoutUser().then(() => {
          window.location.href = '/login';
       });
    });
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo}>Ananta CRM</div>
      <nav className={styles.nav}>
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`${styles.navItem} ${activeTab === item.id ? styles.navItemActive : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            <span className={styles.icon}>{item.icon}</span>
            {item.label}
          </button>
        ))}
        
        <div style={{ marginTop: 'auto', paddingTop: '20px' }}>
          <button 
            className={styles.navItem} 
            onClick={handleLogout}
            style={{ color: '#ef4444' }}
          >
            <span className={styles.icon}>🚪</span>
            Logout
          </button>
        </div>
      </nav>
    </aside>
  );
};
export default Sidebar;
